import tooltipActive from '../media/Tooltip.png';
import tooltipDisabled from '../media/TooltipDisabled.png';

export const FeedbackTooltip = ({ onClick, isActive, identifier="default-tooltip" }) => {
    return (
      <button 
        onClick={onClick}
        style={{
            background: 'transparent',
            border: 'none',
            padding: 0,
            outline: 'none',
            cursor: 'pointer',
            position: 'relative',
            width: '32px',
            height: '32px',
            overflow: 'visible' // Important to show the full image outside button bounds
        }}
        data-cy={identifier}>
        <img 
          src={isActive ? tooltipActive : tooltipDisabled}
          alt="feedback"
          width="234"
          height="234"
          style={{
            display: 'block',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            pointerEvents: 'none',
            transformOrigin: 'center center'
          }}
        />
      </button>
    );
};